import 'core-js/stable';
import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/browser';
import Root from './root';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
    tunnel: '/sentry_tunnel',
    integrations: [new BrowserTracing()],
    maxBreadcrumbs: 50,
    tracesSampleRate: 0.5,
    normalizeDepth: 5,
  });
}

ReactDOM.render(<Root />, document.getElementById('root'));
